'use client';

import { useTranslations } from 'next-intl';
import { ArrowUpRight01Icon } from '@terra/ui-icons';
import { IconButton } from '../../../../components/icon-button';
import { Tooltip } from '../../../../components/tooltip';
import type {
  TraceEntityNavigationHandler,
  TraceEntityNavigationTarget,
} from '../context/TraceEntityNavigationContext';

type TraceInlineOpenEntityActionProps = {
  target: TraceEntityNavigationTarget;
  onOpenEntity: TraceEntityNavigationHandler;
};

export function TraceInlineOpenEntityAction({
  target,
  onOpenEntity,
}: TraceInlineOpenEntityActionProps) {
  const t = useTranslations('designSystem.chat.traceEntity');
  const label = t('openEntity', { entityName: t(target.type) });

  return (
    <Tooltip title={label} subtitle={target.label}>
      <IconButton
        size="xs"
        variant="ghost"
        flexShrink={0}
        color="fg.subtle"
        opacity={0}
        transition="opacity 0.15s ease"
        _groupHover={{ opacity: 1 }}
        _groupFocusWithin={{ opacity: 1 }}
        _focusVisible={{ opacity: 1 }}
        aria-label={label}
        stopPropagation
        onClick={() => onOpenEntity(target)}
      >
        <ArrowUpRight01Icon size={12} />
      </IconButton>
    </Tooltip>
  );
}
